'use client';

import type { IChromeConfig } from '@repo/web-chrome/chrome-config/chrome-config';
import { createContext } from 'react';

export const ChromeConfigContext = createContext<IChromeConfig | null>(null);
